import { CircularProgress } from "@mui/material";
import { getAssets, swalSuccess } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useState } from "react";
import styles from "./notify.module.scss";

export const ForgotNotify = () => {
  const router = useRouter();
  const [laoding, setLoading] = useState(false);
  const { email, userTypeSlug } = router.query;

  //handle resend
  const resendToken = async (e) => {
    e.preventDefault();
    //set laoder
    setLoading(true);

    await API.post("/auth/forgot-password", {
      email: email,
      userTypeSlug: userTypeSlug,
    })
      .then((res) => {
        swalSuccess(
          ` We have sent a password reset link to ${email} pelase check your email to proceed`
        );
        router.push({
          pathname: "/forgot-password/email-notify",
          query: { email, userTypeSlug: "student" },
        });
        setLoading(false);
        return true;
      })
      .catch((error) => {
        setLoading(false);
        return false;
      });
    setLoading(false);
    return false;
  };

  return (
    <section className={styles.section_auth}>
      <div className={styles.side_bg}></div>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.left_wrapper}>
            <div className={styles.logo_and_title_wrapper}>
              <Image
                src={getAssets("assets/logo-beta.webp")}
                alt="UniSearch Logo"
                blurDataURL={getAssets("assets/logo-beta.webp")}
                placeholder="blur"
                width={186}
                height={30}
              />
              <div className={styles.title}>
                Discover study abroad opportunities around the world with
                UniSearch
              </div>
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/auth/illustration_forget_password.png"
                )}
                alt="singin"
              />
            </div>
          </div>

          <div className={styles.right_wrapper}>
            <div className={styles.checkEmail}>
              <h3>Check Your Email</h3>
              <p>
                We have sent a password reset link to <strong> {email}</strong>{" "}
                <br />
                pelase check your email to proceed
              </p>
              <p>
                Did’t receive an email?{" "}
                <button
                  className={styles.tryAgain}
                  onClick={resendToken}
                  disabled={laoding}
                >
                  {laoding && <CircularProgress size={15} color="inherit" />}{" "}
                  Try Again
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotNotify;
